import { AfterViewInit, Component } from '@angular/core';
import { Router } from '@angular/router';
import { LMNavigationService } from './lm-navigation.service';
import { LMUrlUtilService } from '@app/services';

@Component({
  selector: 'lm-navigation',
  template: `<div>Redirecting...</div>`,
})
export class LMNavigationComponent implements AfterViewInit {

  constructor(
    private router: Router,
    private lmNavigationService: LMNavigationService,
    private lmUrlUtilService: LMUrlUtilService
  ) {}

  ngAfterViewInit() {
    this.redirect(this.router.url);
  }

  redirect(navigationUrl: string) {
    // append 'output=spec' so we can retrieve the redirect url in a json format.
    navigationUrl = this.lmUrlUtilService.updateUrlParams(navigationUrl, { output: 'spec' });
    this.lmNavigationService.runNavigation(navigationUrl, undefined, { replaceUrl: true });
  }

  checkSaveRequired() {
    return false;
  }

  public allowPageNavigation(): Promise<boolean> | boolean {
    return true;
  }
}
